<a
  [routerLink]="path"
  [routerLinkActiveOptions]="{ exact: false }"
  [queryParams]="{ view: viewService.currentView() }"
  routerLinkActive="active">
  @if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  <ng-content></ng-content>
</a>
